"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Svg_1 = require("./Svg");
const Path_1 = require("./Svg/Path");
const Phone = ({ color = 'primary', ...rest }) => (React.createElement(Svg_1.default, Object.assign({}, rest),
    React.createElement(Path_1.default, { isStroke: true, d: "M13.523 21.79c-2.665-2.672-1.72-4.756-.273-6.203l.934-.933a2.38 2.38 0 0 1 3.367 0l4.04 4.042a1.39 1.39 0 0 1-.458 2.272 13.881 13.881 0 0 1-18.1-18.101 1.39 1.39 0 0 1 2.271-.459L9.35 6.447c.93.93.93 2.437 0 3.367l-.934.934c-1.444 1.444-3.53 2.392-6.202-.273", color: color, strokeWidth: "2", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" })));
exports.default = Phone;
